var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-gray-700",attrs:{"href":"#","aria-label":"Cancel creation","title":_vm.$t('commons.cancel')},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', $event)}}},[_c('IconUndo',{attrs:{"width":"16","height":"16"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }